import { SystemCredentialsActionTypes } from "us.common/constants";
import { initialState } from "./State";

const {
  GET_SYSTEM_CREDENTIALS,
  GET_SYSTEM_CREDENTIALS_SUCCESS,
  GET_SYSTEM_CREDENTIALS_FAIL,
} = SystemCredentialsActionTypes;

export default (state = initialState, action: any) => {
  switch (action.type) {
    case GET_SYSTEM_CREDENTIALS:
      return Object.assign({}, state, {
        userCredentials: initialState.userCredentials,
      });
    case GET_SYSTEM_CREDENTIALS_SUCCESS:
      return Object.assign({}, state, {
        userCredentials: action.payload.data,
      });
    case GET_SYSTEM_CREDENTIALS_FAIL:
      return Object.assign({}, state, {
        userCredentials: initialState.userCredentials,
      });
    default:
      return state;
  }
};
